import { render } from "./AttendanceEditor.vue?vue&type=template&id=fd8071dc"
import script from "./AttendanceEditor.vue?vue&type=script&lang=js"
export * from "./AttendanceEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__